// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1_mj3","header":"MergedInvoice_header__2OGsK"};